export const formName = 'learningSchedule';

export const fieldLearningKpi = 'learningKpi';
export const fieldLearningThreshold = 'learningThreshold';

export const relearningConditionForm = {
  form: formName,
  enableReinitialize: true,
};
